import OCPLogo from "../../assets/clientslogos/OCP-Group-logo.png";
import BymaroLogo from "../../assets/clientslogos/bymaro-logo.png";
import CepsaLogo from "../../assets/clientslogos/Cepsa-logo.png";
import TGCCLogo from "../../assets/clientslogos/TGCC-logo.png";
import BBEnergyLogo from "../../assets/clientslogos/bbEnergy-logo.png";
import MinistereLogo from "../../assets/clientslogos/Ministere-EE-Logo.jpg";
import ColasLogo from "../../assets/clientslogos/Colas_logo_vector.png";
import SogeaLogo from "../../assets/clientslogos/sogea_maroc_logo.jpg";
import TotalEnergiesLogo from "../../assets/clientslogos/totalEnergies-logo.png";

const Clients = () => {
  const clients = [
    { name: "OCP", logo: OCPLogo, description: "Groupe OCP" },
    {
      name: "BYMARO",
      logo: BymaroLogo,
      description: "Groupe Bouygues Construction",
    },
    { name: "CEPSA", logo: CepsaLogo, description: "Cepsa Energy" },
    {
      name: "TGCC",
      logo: TGCCLogo,
      description: "Travaux Généraux de Construction de Casablanca",
    },
    { name: "BB Energy", logo: BBEnergyLogo, description: "BB Energy" },
    {
      name: "Ministère",
      logo: MinistereLogo,
      description: "Ministère de l'Équipement et de l'Eau",
    },
    { name: "Colas", logo: ColasLogo, description: "Colas Maroc" },
    {
      name: "SOGEA",
      logo: SogeaLogo,
      description: "Groupe VINCI Construction",
    },
    {
      name: "TotalEnergies",
      logo: TotalEnergiesLogo,
      description: "TotalEnergies",
    },
  ];

  return (
    <section id="clients" className="py-20 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-secondary font-semibold text-sm uppercase tracking-wider mb-4">
            Nos Partenaires
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Ils Nous Font
            <span className="text-primary"> Confiance</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            GRAMAGEC collabore avec les plus grands acteurs du BTP au Maroc pour
            la réalisation de projets d'envergure.
          </p>
        </div>
        <div className="relative w-full overflow-hidden bg-gradient-to-r from-white/5 to-white/10 rounded-2xl py-8 md:py-12 mb-16 backdrop-blur-sm">
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />
          <div
            className="flex gap-8"
            style={{
              animation: `marquee ${clients.length * 5}s linear infinite`,
              width: "fit-content",
            }}>
            {[...clients, ...clients].map((client, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-40 h-40 px-4 flex items-center justify-center group">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-40 max-w-full object-contain filter hover:drop-shadow-lg hover:scale-110 transition-all duration-300"
                />
              </div>
            ))}
          </div>
          <style>{`
            @keyframes marquee {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-${9 * 160}px - ${8 * 32}px));
              }
            }
          `}</style>
        </div>
        <div className="bg-gradient-to-r from-primary to-primary/80 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-primary-foreground mb-4">
            Projets Majeurs Réalisés
          </h3>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-primary-foreground/90">
            <span>Campus UM6P Benguerir</span>
            <span className="hidden md:inline">•</span>
            <span>CHU Benguerir</span>
            <span className="hidden md:inline">•</span>
            <span>École Américaine</span>
            <span className="hidden md:inline">•</span>
            <span>Corridor Benguerir-Mzinda</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
